<template>
    <div>
      <a-row :gutter="20">
        <a-col :span="16" class="left-panel">
          <div class="title info-row">
            数据范围选择
          </div>
        </a-col>
        <a-col :span="8" class="right-panel">
          <div class="title info-row">
            导出结构配置
          </div>
          <div class=" group-title info-row">
            导出格式：excel
          </div>
          <div class="export-btn" >
            <a-button type="primary" @click="createExportHandle" :loading="loading" v-if="!data.id">导出</a-button>
          </div>
        </a-col>
      </a-row>
    </div>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'Type9',
    props:{
      data:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    data(){
      return {
        loading:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
      }
    },
    methods:{
      loadData(){

      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      createExportHandle(){
        const params = {
          formatType:'1',
          projectId:this.projectId,
          type:'9'
        }
        this.loading = true
        postAction('/export/projectExport/create',params).then(res=>{
          if(res.success){
            this.$emit("back")
            this.$message.success(res.message)
          }else{
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped>

</style>